import { css } from 'styled-components';
import reduce from 'lodash/reduce';

export const MOBILE = 'mobile';

const sizes = {
  [MOBILE]: 998,
};

const mediaQueries = reduce(
  sizes,
  (accumulator, value, label) => {
    const emSize = value / 16;
    return {
      ...accumulator,
      [label]: (...args) => css`
        @media (max-width: ${emSize}em) {
          ${css(...args)}
        }
      `,
    };
  },
  {},
);

export default mediaQueries;
export { sizes };
